import { Map, Set } from 'immutable';
import { validateField } from './newsletterFormBlockValidation';
export const genderValues = [
    'V',
    'M',
    'A'
];
export const genderLabels = {
    V: 'Vrouw',
    M: 'Man',
    A: 'Anders'
};
export const branches = [
    'Alblasserdam',
    'Arkel',
    'Barendrecht Carnisselande',
    'Barendrecht Het Kruispunt',
    'Bleskensgraaf',
    'Boven-Hardinxveld',
    'Dordrecht Crabbehof',
    'Dordrecht Dubbeldam',
    'Dordrecht Stadsbibliotheek',
    'Dordrecht Stadspolders',
    'Dordrecht Sterrenburg',
    'Giessenburg',
    'Gorinchem centrum',
    'Gorinchem Het Gebouw',
    'Groot-Ammers',
    'Hardinxveld-Giessendam',
    'Hendrik-Ido-Ambacht',
    'Heerjansdam',
    'Nieuw-Lekkerland',
    'Nieuwpoort',
    'Noordeloos',
    'Papendrecht',
    'Poortugaal',
    'Portland',
    'Ridderkerk Bolnes',
    'Ridderkerk centrum',
    'Ridderkerk Slikkerveer',
    'Sliedrecht',
    'Zwijndrecht Kubiek',
    'Zwijndrecht Walburg'
];
export const newsletters = [
    'Nieuwsbrief',
    'Nieuws VE',
    'Nieuws PO',
    'Nieuws VO',
    'Nieuws Leesclubs',
    'Nieuws programmering en collectie',
    'Klantonderzoek'
];
export const newsletterLabels = {
    'Nieuwsbrief': 'Blijf maandelijks op de hoogte van jouw bieb, om meer te beleven met de bibliotheek',
    'Nieuws VE': 'Uitnodigingen voor bijeenkomsten, tips en nieuws voor professionals in de voorschoolse educatie',
    'Nieuws PO': 'Uitnodigingen voor bijeenkomsten, tips en nieuws voor professionals in het primair onderwijs',
    'Nieuws VO': 'Uitnodigingen voor bijeenkomsten, tips en nieuws voor professionals in het voortgezet onderwijs',
    'Nieuws Leesclubs': 'De nieuwsbrief speciaal voor leesclubs. Met updates en leestips',
    'Nieuws programmering en collectie': 'Ontvang uitnodigingen en aanbiedingen die aansluiten bij jouw interesses',
    'Klantonderzoek': 'Geef je mening over de Bibliotheek AanZet'
};
export const initialFormState = {
    firstName: '',
    initials: '',
    infix: '',
    lastName: '',
    emailAddress: '',
    dateOfBirth: (()=>{
        const date = new Date();
        date.setFullYear(date.getFullYear() - 25);
        return date;
    })(),
    gender: 'A',
    branch: branches[0],
    newsletters: Set()
};
export const allFields = Object.keys(initialFormState);
export const initialState = {
    data: initialFormState,
    visited: Set(),
    validationMessages: Map(),
    status: 'initial'
};
export const setFieldOnState = (setState)=>(field)=>(value)=>setState((s)=>({
                    ...s,
                    data: {
                        ...s.data,
                        [field]: value
                    }
                }));
export const toggleNewsletterOnState = (setState)=>(value)=>setState((s)=>({
                ...s,
                data: {
                    ...s.data,
                    newsletters: s.data.newsletters.has(value) ? s.data.newsletters.remove(value) : s.data.newsletters.add(value)
                }
            }));
export const setVisited = (setState)=>(field)=>setState((s)=>({
                ...s,
                visited: s.visited.add(field)
            }));
export const validateFormData = (setState)=>(all)=>setState((prevState)=>{
            const fields = all ? allFields : prevState.visited.toArray();
            const validationMessages = validateFields(fields, prevState.data);
            // When "all fields" is triggered once, ensure all is validated on updates
            const visited = Set(fields);
            return {
                ...prevState,
                validationMessages,
                visited
            };
        });
export const validateFields = (fields, data)=>fields.reduce((messages, field)=>{
        const result = validateField(field)(data[field]);
        return result.status == 'invalid' ? messages.set(field, result.message) : messages;
    }, Map());
